import AIResults from 'components/TripScreen/TripPlanScreen/AIResults';
import ButtonGroup from 'components/common/ButtonGroup';
import CardScreenHeader from 'components/common/CardScreenHeader';
import TripPlanContent from 'components/TripScreen/TripPlanScreen/TripPlanContent/TripPlanContent';
import TripPlanMap from 'components/TripScreen/TripPlanScreen/TripPlanMap';
// import analytics from 'utils/analytics';
import { useSendWithLoaderConfig } from '../../../context/loaderContext';
import googlemaps from 'utils/googlemaps';
import lokalise from 'utils/lokalise';
import tripscreen from 'utils/tripscreen';

function TripPlanScreen({
    selectedTripPlan,
    showTripPlanScreen,
    setTripPlanScreen,
    startingLocation,
    endingLocation,
    params
}) {

    const sendWithLoaderConfig = useSendWithLoaderConfig();

    function dimissScreen() {
        setTripPlanScreen(false);
    }

    function getGMLinkStartToFirst() {
        // Translate Journey API name field to Google Maps travelmode param
        let travelMode = "walking";
        if (selectedTripPlan.name === "Transit") {
            travelMode = "transit"; 
        } else if (selectedTripPlan.name === "Car" || selectedTripPlan.name === "Driving and Parking") {
            travelMode = "driving";
        } else if (selectedTripPlan.name === "Bicycle") {
            travelMode = "bicycling";
        }
        const destinationLocation = {
            coords: {
                latitude: selectedTripPlan.legs[0].to.coordinates.latitude,
                longitude: selectedTripPlan.legs[0].to.coordinates.longitude,
            }
        }
        const url = googlemaps.getGMDirectionsURL({ startingLocation, endingLocation: destinationLocation, travelMode });
        return url;

    }

    const buttons = [
        ...('externalLinks' in params && params['externalLinks'] === 'true' ? [{
            iconCategory: 'ui',
            iconName: 'googleMapsIcon',
            text: lokalise.getKey('button_start_your_trip'),
            onClick: () => {
                const targetUrl = getGMLinkStartToFirst();
                sendWithLoaderConfig({ googleMapsUrl: targetUrl }, 'google-maps-opened');
                const newWindow = window.open(targetUrl, "_blank", "noopener,noreferrer");
                if (!newWindow || newWindow.closed || typeof newWindow.closed === "undefined") {
                    const a = document.createElement("a");
                    a.href = targetUrl;
                    a.target = "_blank";
                    a.rel = "noopener noreferrer";
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                }
            }
        }]
        : []),
        ...(selectedTripPlan?.category === 'RideHailing'
            ? [{
                iconCategory: 'modes',
                iconName: 'floating',
                text: 'Open Uber',
                onClick: () => {
                    const pickup = startingLocation?.coords;
                    const dropoff = endingLocation?.coords;
                    if (!pickup || !dropoff) return;

                    const uberAppUrl = `uber://?action=setPickup&pickup[latitude]=${pickup.latitude}&pickup[longitude]=${pickup.longitude}&dropoff[latitude]=${dropoff.latitude}&dropoff[longitude]=${dropoff.longitude}`;
                    const uberWebUrl = `https://m.uber.com/ul/?action=setPickup&pickup[latitude]=${pickup.latitude}&pickup[longitude]=${pickup.longitude}&dropoff[latitude]=${dropoff.latitude}&dropoff[longitude]=${dropoff.longitude}`;

                    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

                    if (!isMobile) {
                        window.open(uberWebUrl, '_blank');
                    } else {
                        window.location.href = uberAppUrl;
                        setTimeout(() => {
                            window.location.href = uberWebUrl;
                        }, 1500);
                    }
                }
            }]
            : [])
    ];
    

    function getScreenHeaderText() {
        const duration = selectedTripPlan?.duration?.high ? selectedTripPlan?.duration : selectedTripPlan?.scores?.duration;
        if (duration) {
            return <>
                {lokalise.getKey('tripplan_min_trip', { time: tripscreen.getDuration(duration) })} <span className="divider">/</span> {tripscreen.getEstimatedArrival(duration / 60)}
            </>
        }
        return '';
    };

    return (
        <div className="TripPlanScreen">

            <header className="screen-header">
                <CardScreenHeader text={getScreenHeaderText()} tapEvent={() => dimissScreen()} />
            </header>

            <div className="body">

                <div className="map">
                    <TripPlanMap showTripPlanScreen={showTripPlanScreen} tripPlan={selectedTripPlan} startingLocation={startingLocation} endingLocation={endingLocation} />
                </div>

                <div className="content">
                    <h2>{lokalise.getKey('tripplan_what_to_expect')}</h2>
                    <TripPlanContent name={selectedTripPlan?.name} tripPlan={selectedTripPlan} endingLocation={endingLocation} params={params} />
                    <ButtonGroup buttons={buttons}></ButtonGroup>
                    <AIResults tripOption={selectedTripPlan} />
                </div>

            </div>
        </div>
    )
}

export default TripPlanScreen
